@let result = result$ | async;
<onyx-modal
  variant="center"
  [size]="980"
  [heading]="result?.heading"
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
>
  @let hasErrors = !!result?.errors?.length;
  @if (hasErrors) {
    <onyx-icon
      headingIcon
      name="error-circle-two-tone-filled"
      [size]="24"
    ></onyx-icon>
  }

  @if (hasErrors && result?.errors; as errors) {
    <div class="container">
      <p>{{ `${I18N}.errorMessage` | translate }}</p>

      @for (error of errors; track $index) {
        <p class="f-paragraph-s">
          {{ 'labels.row' | translate }}
          <span class="f-paragraph-s f-medium">{{ error.index }}</span
          >, {{ 'labels.section' | translate }}
          <span class="f-paragraph-s f-medium">{{ error.section }}</span
          >, {{ 'labels.column' | translate }}
          <span class="f-paragraph-s f-medium">{{ error.field }}</span> -
          {{ error.issue.message }}
        </p>
      }
    </div>
  } @else {
    <div class="loading">
      <onyx-spinner [size]="48"></onyx-spinner>

      <p class="f-body-l f-medium">
        @if (result) {
          {{ `${I18N}.loadingProgress` | translate: result }}
        } @else {
          {{ `${I18N}.loading` | translate }}
        }
      </p>
    </div>
  }

  <ng-container bottomRightOptions>
    @if (result?.data?.length && result?.data; as data) {
      <onyx-button (click)="import(data)">
        {{ `${I18N}.continue` | translate: { count: data.length } }}
      </onyx-button>
    }
  </ng-container>
</onyx-modal>
